import React, { useContext, useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { useForm } from '../../../Hooks/useForm';
import { AuthContext } from '../../../Context/AuthContext/AuthContext';
import { toastShow } from '../../../Services/ToastService';
import { Toast } from 'primereact/toast';
import { confirmDialog } from 'primereact/confirmdialog';
import { useRef } from 'react';
import { postSolicitudEdicionProv } from '../../../../Base/API/Proveedores/ProveedoresRequest';
import { getDateTimeStringSQL24 } from '../../../Services/Moment/Luxon';
import { InputTextarea } from 'primereact/inputtextarea';
import { sendEmail } from '../../../Services/Email/EmailRequest';
import { getCorreos } from '../../../../Base/API/IT/ListaCorreos/ListaCorreosRequest';

const ModalSolicitudEdicionProveedor = ({ visible, onHide, IdProveedor, IdStatus, proveedorData, onSuccess, toast }) => {
  const [loading, setLoading] = useState(false);
  const { userAuth } = useContext(AuthContext);
  const proveedorActivo = IdStatus === 1;
  const soloHabilitarPago = proveedorData?.IdStatusRevision === 3722;
  const SECCIONES = [
    { key: 'InformacionEmpresa', labelEs: 'Información de Empresa', labelEn: 'Company Information' },
    { key: 'InformacionContacto', labelEs: 'Información de Contacto', labelEn: 'Contact Information' },
    { key: 'InformacionBancaria', labelEs: 'Información Bancaria', labelEn: 'Banking Information' },
    { key: 'InformacionComercial', labelEs: 'Información Comercial', labelEn: 'Commercial Information' },
    { key: 'InformacionFinanciera', labelEs: 'Información Financiera', labelEn: 'Financial Information' },
    { key: 'Documentacion', labelEs: 'Documentación', labelEn: 'Documentation' },
    { key: 'Reactivar', labelEs: 'Reactivar', labelEn: 'Reactivation' },
    { key: 'HabilitarPago', labelEs: 'Habilitar Pago', labelEn: 'Enable Payment' },
  ];
  const { values, setValues, resetForm } = useForm({
    IdProveedor: IdProveedor ?? null,
    IdUserCreate: userAuth.idUser,
    InformacionEmpresa: false,
    InformacionContacto: false,
    InformacionBancaria: false,
    InformacionComercial: false,
    InformacionFinanciera: false,
    Documentacion: false,
    Comentario: '',
    Reactivar: false,
    HabilitarPago: false,
  });

  const checkboxes = [
    { field: 'InformacionEmpresa', label: 'Información de empresa' },
    { field: 'InformacionContacto', label: 'Información de contacto' },
    { field: 'InformacionBancaria', label: 'Información bancaria' },
    { field: 'InformacionComercial', label: 'Información comercial' },
    { field: 'InformacionFinanciera', label: 'Información financiera' },
    { field: 'Documentacion', label: 'Documentación' },
  ];

  const alMenosUno = checkboxes.some((c) => values[c.field]) ||
    values.Reactivar || values.HabilitarPago;

  const EnviarCorreoNotificacionSolicitud = async (solicitudCreada) => {
    const correoDestino = 'jpineda@ppf.com.hn, lmedina@ppf.com.hn';

    if (!correoDestino) {
      toastShow(toast, 'warn', 'Solicitud guardada, pero el proveedor no tiene correo registrado');
      return;
    }

    console.log(solicitudCreada);

    try {
      const correos = await getCorreos(28);

      const seccionesMarcadas = SECCIONES.filter((s) => !!solicitudCreada[s.key]);
      const listaEs = seccionesMarcadas.length > 0
        ? `<ul>${seccionesMarcadas.map((s) => `<li>${s.labelEs}</li>`).join('')}</ul>`
        : '';

      const contenidoEs = `<div>
        <p>Correlativo: <strong>${solicitudCreada.Correlativo}</strong></p>
        <p>Estimado Proveedor: <strong>${proveedorData?.CustomerName}</strong></p>
        <p>Le informamos que hemos recibido su solicitud de edición de información, la cual se encuentra <strong>pendiente de revisión</strong>.</p>
        <p>Las siguientes secciones fueron solicitadas:</p>
        ${listaEs}
        <p>Comentario adicional: ${solicitudCreada?.Comentario || 'Ninguno'}</p>
        <p>*Correo generado automáticamente, por favor no responder.</p>
        <p>Saludos cordiales.</p>
        <br />
      </div>`;



      const objeto = {
        to: correos[0].DestinatariosMail,
        cc: correos[0].CCMail + ',' + userAuth?.Mail,
        bcc: correos[0].CCoMail,
        subject: 'Solicitud de edición recibida',
        html: contenidoEs,
      };

      const result = await sendEmail(objeto);
      if (!result) {
        toastShow(toast, 'warn', 'Solicitud guardada, pero el correo no se pudo enviar');
      }
    } catch {
      toastShow(toast, 'warn', 'Solicitud guardada, pero el correo no se pudo enviar');
    }
  };

  const guardar = () => {
    if (loading) return;

    if (!alMenosUno) {
      toastShow(toast, 'error', 'Debe seleccionar al menos una sección');
      return;
    }

    confirmDialog({
      message: '¿Desea enviar la solicitud de edición?',
      header: 'Confirmación',
      icon: 'pi pi-exclamation-triangle',
      accept: async () => {
        if (loading) return;
        setLoading(true);
        try {
          const payload = {
            ...values,
            IdProveedor,
            DateCreate: getDateTimeStringSQL24(new Date()),
          };
          const result = await postSolicitudEdicionProv(payload);
          toastShow(toast, 'success', 'Solicitud enviada correctamente');


          const solicitudCreada = {
            ...values,
            Correlativo: result?.[0]?.Correlativo ?? null
          };

          await EnviarCorreoNotificacionSolicitud(solicitudCreada);

          onSuccess?.();
          handleHide();
        } catch {
          toastShow(toast, 'error', 'No se pudo guardar la solicitud');
        } finally {
          setLoading(false);
        }
      },
    });
  };

  const handleCheckboxChange = (field, checked) => {
    if (field === 'HabilitarPago') {
      if (checked) {
        setValues((prev) => ({
          ...prev,
          HabilitarPago: true,
          InformacionEmpresa: false,
          InformacionContacto: false,
          InformacionBancaria: false,
          InformacionComercial: false,
          InformacionFinanciera: false,
          Documentacion: false,
        }));
      } else {
        setValues((prev) => ({
          ...prev,
          HabilitarPago: false,
        }));
      }

      return;
    }

    setValues((prev) => ({
      ...prev,
      [field]: checked,
      HabilitarPago: false,
    }));
  };

  const handleHide = () => {
    resetForm({
      IdProveedor: null,
      IdUserCreate: userAuth.idUser,
      InformacionEmpresa: false,
      InformacionContacto: false,
      InformacionBancaria: false,
      InformacionComercial: false,
      InformacionFinanciera: false,
      Documentacion: false,
      Comentario: '',
      Reactivar: false,
      HabilitarPago: false,
    });
    onHide();
  };

  useEffect(() => {
    if (proveedorActivo && values.Reactivar) {
      setValues((prev) => ({ ...prev, Reactivar: false }));
    }
  }, [proveedorActivo]);

  return (
    <Dialog
      visible={visible}
      onHide={handleHide}
      header="Solicitud de edición de proveedor"
      style={{ width: '400px' }}
      footer={
        <div className="d-flex justify-content-end gap-2">
          <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={handleHide} />
          <Button label="Guardar" icon="pi pi-save" onClick={guardar} loading={loading} disabled={!alMenosUno || loading} />
        </div>
      }
    >
      <div className="d-flex flex-column gap-3">
        {checkboxes.map(({ field, label }) => (
          <div key={field} className="d-flex align-items-center gap-2">
            <Checkbox
              inputId={field}
              checked={values[field]}
              disabled={!proveedorActivo || values.HabilitarPago === true || soloHabilitarPago}
              onChange={(e) => setValues((prev) => ({ ...prev, [field]: e.checked }))}
            />
            <label htmlFor={field}
              style={{
                cursor: !proveedorActivo || soloHabilitarPago ? 'not-allowed' : 'pointer',
                opacity: !proveedorActivo || soloHabilitarPago ? 0.5 : 1,
              }}>{label}</label>
          </div>
        ))}

        <hr className="my-1" />
        {userAuth?.IdRol === 2 && (
          <div className="d-flex align-items-center gap-2">
            <Checkbox
              inputId="HabilitarPago"
              checked={values.HabilitarPago}
              disabled={!proveedorActivo || !soloHabilitarPago}
              onChange={(e) => handleCheckboxChange('HabilitarPago', e.checked)}
            />
            <label htmlFor="HabilitarPago" style={{ cursor: !proveedorActivo || !soloHabilitarPago ? 'not-allowed' : 
                'pointer', opacity: !proveedorActivo || !soloHabilitarPago ? 0.5 : 1 }}>
              Habilitar pago
            </label>
          </div>
        )}

        <div className="d-flex align-items-center gap-2">
          <Checkbox
            inputId="Reactivar"
            checked={values.Reactivar}
            disabled={proveedorActivo || !soloHabilitarPago}
            onChange={(e) => setValues((prev) => ({ ...prev, Reactivar: e.checked }))}
          />
          <label htmlFor="Reactivar" style={{
            cursor: proveedorActivo || !soloHabilitarPago ? 'not-allowed' : 'pointer',
            opacity: proveedorActivo || !soloHabilitarPago ? 0.5 : 1,
          }}>
            Reactivar proveedor
          </label>
        </div>

        <div className="d-flex flex-column gap-2">
          <label htmlFor="Comentario">
            Comentario
          </label>

          <InputTextarea
            id="Comentario"
            className="w-100"
            rows={4}
            value={values.Comentario}
            onChange={(e) =>
              setValues((prev) => ({ ...prev, Comentario: e.target.value, }))}
            placeholder="Ingrese un comentario..."
            autoResize
          />
        </div>

      </div>
    </Dialog>
  );
};

export default ModalSolicitudEdicionProveedor;